<!-- ============================================================================ -->
<!-- VARIANTE: COURSE-EDITOR -->
<!-- ============================================================================ -->
@if (variant === 'course-editor') {
<div
  class="bg-white shadow-sm border-s border-gray-200 dark:bg-neutral-800 dark:border-neutral-700 h-full flex flex-col"
>
  <div
    class="p-4 border-b border-gray-200 dark:border-neutral-700 flex-shrink-0"
  >
    <h3 class="text-md font-semibold text-gray-900 dark:text-white mt-1 !mb-0">
      Informações do Curso
    </h3>
  </div>

  <div class="flex-1 overflow-y-auto">
    <!-- Tabs Navigation -->
    <div class="border-b border-gray-200 dark:border-neutral-700 pt-[0.85rem]">
      <nav class="flex -mb-px" aria-label="Tabs" role="tablist">
        <button
          type="button"
          class="hs-tab-active:border-[var(--color-primary)] hs-tab-active:text-[var(--color-primary)] py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium text-center text-gray-500 hover:text-gray-700 focus:outline-none focus:text-[var(--color-primary)] disabled:opacity-50 disabled:pointer-events-none active border-b-2 border-transparent"
          id="hs-tab-resumo"
          data-hs-tab="#hs-tab-panel-resumo"
          aria-controls="hs-tab-panel-resumo"
          role="tab"
          aria-selected="true"
        >
          Resumo
        </button>
        <button
          type="button"
          class="hs-tab-active:border-[var(--color-primary)] hs-tab-active:text-[var(--color-primary)] py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium text-center text-gray-500 hover:text-gray-700 focus:outline-none focus:text-[var(--color-primary)] disabled:opacity-50 disabled:pointer-events-none border-b-2 border-transparent"
          id="hs-tab-edicao"
          data-hs-tab="#hs-tab-panel-edicao"
          aria-controls="hs-tab-panel-edicao"
          role="tab"
          aria-selected="false"
        >
          Edição
        </button>
      </nav>
    </div>

    <!-- Tabs Content -->
    <div class="p-4">
      <!-- Tab Panel: Resumo -->
      <div
        id="hs-tab-panel-resumo"
        role="tabpanel"
        aria-labelledby="hs-tab-resumo"
      >
        <div class="space-y-4">
          <div class="grid grid-cols-2 gap-4">
            <div
              class="rounded border border-gray-200 bg-gray-50 p-4 shadow-sm"
            >
              <div class="text-sm text-gray-600 dark:text-neutral-400 mb-1">
                Módulos
              </div>
              <div class="text-2xl font-semibold text-gray-900 dark:text-white">
                {{ totalModules }}
              </div>
            </div>
            <div
              class="rounded border border-gray-200 bg-gray-50 p-4 shadow-sm"
            >
              <div class="text-sm text-gray-600 dark:text-neutral-400 mb-1">
                Lições
              </div>
              <div class="text-2xl font-semibold text-gray-900 dark:text-white">
                {{ totalLessons }}
              </div>
            </div>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <div
              class="rounded border border-gray-200 bg-gray-50 p-4 shadow-sm"
            >
              <div class="text-sm text-gray-600 dark:text-neutral-400 mb-1">
                Questões
              </div>
              <div class="text-2xl font-semibold text-gray-900 dark:text-white">
                {{ totalQuestions }}
              </div>
            </div>
            <div
              class="rounded border border-gray-200 bg-gray-50 p-4 shadow-sm"
            >
              <div class="text-sm text-gray-600 dark:text-neutral-400 mb-1">
                Pontos Totais
              </div>
              <div class="text-2xl font-semibold text-gray-900 dark:text-white">
                {{ totalEvaluationPoints }}
              </div>
            </div>
          </div>

          <div class="rounded border border-gray-200 bg-gray-50 p-4 shadow-sm">
            <div class="text-sm text-gray-600 dark:text-neutral-400 mb-1">
              Tempo Total do Curso
            </div>
            <div class="text-2xl font-semibold text-gray-900 dark:text-white">
              {{ formatDuration(totalCourseDuration) }}
            </div>
          </div>
        </div>
      </div>

      <!-- Tab Panel: Edição -->
      <div
        id="hs-tab-panel-edicao"
        class="hidden"
        role="tabpanel"
        aria-labelledby="hs-tab-edicao"
      >
        <!-- Aviso de Impacto -->
        <div
          class="mb-4 rounded border border-amber-200 bg-amber-50 p-3 relative"
        >
          <div class="absolute top-0 right-2">
            <i
              class="bi bi-exclamation-triangle-fill text-amber-600 dark:text-amber-400 flex-shrink-0 text-[12px]"
            ></i>
          </div>
          <div class="gap-2">
            <div class="flex-1 space-y-2">
              <p class="text-sm text-amber-800 dark:text-amber-300">
                As alterações realizadas nesta seção terão impacto direto em
                todas as outras aplicações do sistema (Admin, Portal,
                Visualizador de cursos, etc.).
              </p>
              <p class="text-sm text-amber-800 dark:text-amber-300">
                Certifique-se de que as informações estão corretas antes de
                salvar.
              </p>
            </div>
          </div>
        </div>

        <form [formGroup]="courseForm" (ngSubmit)="onSave()" class="space-y-4">
          <div>
            <label
              for="course-title"
              class="mb-1 block text-sm font-medium text-gray-700"
            >
              Título do Curso
            </label>
            <input
              type="text"
              id="course-title"
              formControlName="title"
              class="form-field-control placeholder-gray-500"
              [class.border-red-500]="isFieldInvalid('title')"
              placeholder="Digite o título do curso"
            />
            <p
              *ngIf="isFieldInvalid('title')"
              class="mt-1 text-sm text-red-600"
            >
              {{ getFieldError('title') }}
            </p>
          </div>

          <div>
            <label
              for="course-description"
              class="mb-1 block text-sm font-medium text-gray-700"
            >
              Descrição
            </label>
            <textarea
              id="course-description"
              formControlName="description"
              rows="4"
              class="form-field-textarea placeholder-gray-500"
              [class.border-red-500]="isFieldInvalid('description')"
              placeholder="Digite a descrição do curso"
            ></textarea>
            <p
              *ngIf="isFieldInvalid('description')"
              class="mt-1 text-sm text-red-600"
            >
              {{ getFieldError('description') }}
            </p>
          </div>

          <div>
            <label
              for="course-cover"
              class="mb-1 block text-sm font-medium text-gray-700"
            >
              URL da Capa
            </label>
            <input
              type="url"
              id="course-cover"
              formControlName="coverImage"
              class="form-field-control placeholder-gray-500"
              placeholder="https://exemplo.com/imagem.jpg"
            />
            <p class="mt-1 text-xs text-blue-800 dark:text-blue-300">
              URL da imagem de capa do curso
            </p>
          </div>

          <div *ngIf="courseForm.get('coverImage')?.value" class="mt-2">
            <img
              [src]="courseForm.get('coverImage')?.value"
              alt="Preview da capa"
              class="w-full h-32 rounded border border-gray-200 object-cover"
              onerror="this.style.display='none'"
            />
          </div>

          <div class="pt-4 border-t border-gray-200 dark:border-neutral-700">
            <button
              type="submit"
              class="btn-primary w-full"
              [disabled]="courseForm.invalid"
            >
              Salvar Informações
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}

<!-- ============================================================================ -->
<!-- VARIANTE: COURSE-VIEWER -->
<!-- ============================================================================ -->
@if (variant === 'course-viewer') {
<!-- Barra Lateral Direita - Dividida Verticalmente -->
<div class="h-full min-h-0 flex flex-col">
  <!-- Parte Superior: Informações da Lição -->
  <div class="flex-1 min-h-0 overflow-y-auto">
    <div
      class="bg-white shadow-sm border-s border-gray-200 dark:bg-neutral-800 dark:border-neutral-700 h-full flex flex-col"
    >
      <!-- Progresso Geral -->
      <div
        class="mb-0 px-4 py-[0.85rem] border-b border-gray-200 dark:border-neutral-700 flex-shrink-0"
        *ngIf="course"
      >
        <div class="flex items-center justify-between mb-2">
          <span class="text-sm font-medium text-gray-700 dark:text-neutral-300"
            >Progresso do Curso</span
          >
          <span class="text-sm text-gray-600 dark:text-neutral-400"
            >{{ totalProgress }}% concluído</span
          >
        </div>
        <div class="w-full h-2 bg-gray-200 rounded-full dark:bg-neutral-700">
          <div
            class="h-2 rounded-full bg-[var(--color-primary)] transition-all duration-300"
            [style.width]="totalProgress + '%'"
          ></div>
        </div>
      </div>

      <div
        class="p-4 flex-1 overflow-y-auto"
        *ngIf="currentModule && currentLesson"
      >
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">
          {{ displayTitle }}
        </h2>
        <p class="text-gray-500 dark:text-neutral-400 mb-2">
          {{ currentModule.description }}
        </p>
        <p
          *ngIf="currentModule.contentType === 'lessons' && currentModule.lessons"
          class="inline-flex items-center rounded px-2 py-0.5 text-xs font-medium bg-gray-100 text-gray-700"
        >
          {{ currentModule.lessons.length }} {{ currentModule.lessons.length ===
          1 ? 'lição' : 'lições' }}
        </p>
        <div class="mt-4">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            {{ currentLesson.title }}
          </h3>
          <p class="text-gray-500 dark:text-neutral-400">
            {{ currentLesson.description }}
          </p>
          <div
            class="mt-3 flex items-center gap-2 text-sm text-gray-500 dark:text-neutral-400"
          >
            <i class="bi bi-clock"></i>
            <span>{{ currentLesson.duration }} minutos</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Parte Inferior: Anotações -->
  <div
    class="flex-shrink-0 h-[300px] min-h-[200px] max-h-[400px]"
    *ngIf="currentLesson"
  >
    <app-notes [lessonId]="currentLesson.id" />
  </div>
</div>
}
